// this is a custom React hook to be used for all our components
// [state, stateSubstitute, stateAdd, stateDelete] = useReducerGeneric({initial_state_params, initState})
// let's destructure to local... if used not for the (olnly) global state, but for a local state, like:
// [localstate, localstateSubstitute, localstateAdd, localstateDelete] = useReducerGeneric({initial_state_params, initState})
import { useReducer } from 'react'
import { reducerGeneric, stateChangeGenericDispatch } from './utils'

export function useReducerGeneric<StateType>({
  initial_state_params,
  initState,
}: {
  initial_state_params: StateType
  initState?: any
}): [state: StateType, stateSubstitute: (path: string, part: any) => void, stateAdd: (path: string, part: any) => void, stateDelete: (path: string) => void] {
  const [state, dispatch] = useReducer(reducerGeneric, initial_state_params, initState)

  function stateSubstitute(path: string, part: any) {
    return stateChangeGenericDispatch('SUBSTITUTE', path, part, dispatch)
  }
  function stateAdd(path: string, part: any) {
    return stateChangeGenericDispatch('ADD', path, part, dispatch)
  }
  function stateDelete(path: string) {
    return stateChangeGenericDispatch('DELETE', path, null, dispatch)
  }

  return [state, stateSubstitute, stateAdd, stateDelete]
}
